import { useQuery } from '@apollo/client/react';
import { gql } from '@apollo/client';
import { toast } from 'sonner';

export const INVITED_USERS_QUERY = gql`
  query InvitedUsers {
    invitedUsers {
      id
      email
      fullName
      role
      invitedAt
      createdAt
    }
  }
`;

export function useInvitedUsers() {
  const { data, loading, error, refetch } = useQuery(INVITED_USERS_QUERY, {
    fetchPolicy: 'network-only',
    onError: (error: any) => {
      const message = error.graphQLErrors?.[0]?.message || error.message || 'Failed to load invited users';
      toast.error(message);
    },
  } as any);

  return {
    invitedUsers: (data as any)?.invitedUsers || [],
    loading,
    error,
    refetch,
  };
}
